import React from "react";

import { Attendee } from "../../../api";
import AttendeeDetails from "../../../components/Events/AttendeeDetails";
import AttendeeScores from "../../../components/Events/AttendeeScores";

export interface AttendeeInfoSidebarProps extends Attendee {
}

const AttendeeInfoSidebar: React.FC<AttendeeInfoSidebarProps> = (props) => {

  return (
    <>

      <div className="m-3">
        <div style={{ position: "relative" }}>
          <AttendeeDetails {...props} showContactInfo />
        </div>
      </div>

      {!!props?.scores && (
        <div className="m-3">
          <div className="position-relative">
            <AttendeeScores data={props.scores} />
          </div>
        </div>
      )}

    </>
  );
};

export default AttendeeInfoSidebar;
